import { makeAutoObservable } from 'mobx';
import CycleState from '../../../../state/cycles/CycleState';

class AdminRevieweesContainerState {
  match;
  name;

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({match}) {
    this.match = match;
  }

  async load() {
    this.name = await this.getCycleName(this.match.params.id);
  }

  async getCycleName(id) {
    const cycleStore = new CycleState();
    await cycleStore.load();
    cycleStore.selectCycle(id);
    return cycleStore.cycle.title;
  }
}

export default AdminRevieweesContainerState;
